<div class="meine-aufgaben">
  <div class="meine-aufgaben__uebersicht">
    <h2 class="meine-aufgaben__titel">{{ 'home.aufgaben.titel' | translate }}</h2>

    @switch (store.status()) {
      @case ('laedt') {
        <p class="meine-aufgaben__satz">{{ 'home.aufgaben.laedt' | translate }}</p>
      }
      @case ('fehler') {
        <div class="meine-aufgaben__fehler" role="alert">
          <p class="meine-aufgaben__satz">{{ 'home.aufgaben.fehler' | translate }}</p>
          <button type="button" class="meine-aufgaben__erneut" (click)="store.laden()">
            {{ 'home.aufgaben.erneut' | translate }}
          </button>
        </div>
      }
      @default {
        <p class="meine-aufgaben__satz">
          @for (teil of satz(); track $index) {
            @if (teil.stark) {
              <strong [class.meine-aufgaben__ueberfaellig]="teil.rot">{{ teil.text | translate: teil.params }}</strong>
            } @else {
              <span>{{ teil.uebersetzen ? (teil.text | translate) : teil.text }}</span>
            }
          }
        </p>
      }
    }

    @if (store.status() !== 'fehler') {
      @let laedt = store.status() === 'laedt';
      <div class="meine-aufgaben__kacheln">
        @for (art of store.kacheln(); track art.art) {
          @let anzahl = store.zaehler()[art.art];
          @let aktiv = store.filter() === art.art;
          <button
            type="button"
            data-testid="aufgaben-kachel"
            [class]="'meine-aufgaben__kachel meine-aufgaben__kachel--' + art.art"
            [class.meine-aufgaben__kachel--aktiv]="aktiv"
            [attr.aria-pressed]="aktiv"
            [attr.aria-label]="
              laedt
                ? (art.labelKey | translate)
                : ('home.aufgaben.kachelAria' | translate: { art: (art.labelKey | translate), n: anzahl })
            "
            [disabled]="laedt"
            (click)="store.filterUmschalten(art.art)"
          >
            <span class="meine-aufgaben__kachel-kopf">
              <span class="meine-aufgaben__kachel-icon">
                <mat-icon aria-hidden="true">{{ art.icon }}</mat-icon>
              </span>
              <span class="meine-aufgaben__kachel-zahl" [class.meine-aufgaben__kachel-zahl--leer]="laedt || !anzahl">
                {{ laedt ? '–' : anzahl }}
              </span>
            </span>
            <span class="meine-aufgaben__kachel-label">{{ art.labelKey | translate }}</span>
          </button>
        }
      </div>

      @if (store.nurMail().length > 0) {
        <p class="meine-aufgaben__nur-mail">
          {{ 'home.aufgaben.nurMail' | translate }}
          @for (art of store.nurMail(); track art.art) {
            {{ art.labelKey | translate }}{{ $last ? '' : ',' }}
          }
        </p>
      }
    }

    <div class="meine-aufgaben__verweise">
      <a routerLink="/postfach" class="meine-aufgaben__verweis meine-aufgaben__verweis--postfach">
        <span>{{ 'home.aufgaben.zumPostfach' | translate }}</span>
        <mat-icon aria-hidden="true">chevron_right</mat-icon>
      </a>
      <a
        routerLink="/account"
        fragment="benachrichtigungen"
        class="meine-aufgaben__verweis meine-aufgaben__verweis--einstellungen"
      >
        <mat-icon aria-hidden="true">settings</mat-icon>
        <span>{{ 'home.aufgaben.benachrichtigungen' | translate }}</span>
      </a>
    </div>
  </div>

  <app-aufgaben-liste class="meine-aufgaben__rechts" />
</div>
